exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-39584e3a],html[data-v-39584e3a]{height:100%;background-color:#fff!important}", ""]);

// exports
